import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@h2/ui';
import { Button } from '@h2/ui';
import { 
  FileText,
  Search,
  Globe,
  CheckCircle,
  User,
  Video,
  Settings,
  AlertTriangle
} from 'lucide-react';

// 아이콘 매핑 객체
const iconMap = {
  FileText,
  Search,
  Globe,
  CheckCircle,
  User,
  Video,
  Settings
};

// 아이콘 렌더링 컴포넌트
const TaskTypeIcon: React.FC<{ iconName: string; className?: string }> = ({ iconName, className = "h-6 w-6" }) => {
  const IconComponent = iconMap[iconName as keyof typeof iconMap];
  return IconComponent ? <IconComponent className={className} /> : <Settings className={className} />;
};

interface TaskType {
  id: string;
  name: string;
  memo: string;
  languageDependent: boolean;
  icon: string;
  order: number;
}

interface DeleteConfirmModalProps {
  taskType: TaskType;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  taskType,
  onConfirm,
  onCancel
}) => {
  return (
    <Dialog open onOpenChange={onCancel}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-destructive/10">
              <AlertTriangle className="h-5 w-5 text-destructive" />
            </div>
            <div>
              <DialogTitle>작업유형 삭제</DialogTitle>
              <DialogDescription>
                이 작업을 되돌릴 수 없습니다.
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="space-y-4">
          <div className="rounded-lg border p-4">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800">
                <TaskTypeIcon iconName={taskType.icon} className="h-6 w-6" />
              </div>
              <div>
                <h4 className="font-semibold">{taskType.name}</h4>
                <p className="text-sm text-muted-foreground">{taskType.memo}</p>
              </div>
            </div>
          </div>

          <div className="space-y-2">
            <p className="text-sm font-medium">삭제 시 영향:</p>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• 이 작업유형을 사용하는 기존 워크플로우는 영향받지 않습니다</li>
              <li>• 새로운 워크플로우에서는 더 이상 선택할 수 없습니다</li>
              <li>• 삭제된 작업유형은 복구할 수 없습니다</li>
            </ul>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            취소
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            삭제
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
